import {Link} from "react-router-dom";

export function ContactFooter() {
  return (
    <>
      <div className="footer">
        <div className="footer-column">
          <h1 className="header-1">Openingstijden</h1>
          <p className="header-2">Vrijdag</p>
          <p>9.00 tot 14.00</p>
        </div>

        <div className="footer-column">
          <h1 className="header-1">
            Locatie
          </h1>
          <p>Baljuwstraat, Centrum Ridderkerk</p>

          <div className="button-padding">
            <button className="button">
              <Link
                to="https://www.google.nl/maps/place/Smaeck/@51.8655077,4.6172581,17z/data=!3m1!4b1!4m6!3m5!1s0x47c42dbb689e731f:0x753bb40a2a19a6aa!8m2!3d51.8655077!4d4.6198384!16s%2Fg%2F11v01y1_z1?entry=ttu"
                target="_blank" rel="noopener noreferrer">
                Routebeschrijving
              </Link>
            </button>
          </div>
        </div>

        <div className="footer-column">
          <h1 className="header-1">Contact</h1>

          <p className="header-2">Email</p>
          <p>info@smaeckridderkerk.nl</p>

          <p className="header-2">Telefoonnummer</p>
          <p>06 23835962</p>
        </div>

        <div className="footer-column">
          <h1 className="header-1">Social Media</h1>

          <div className="button-padding">
            <button className="button">
              <Link to="https://www.instagram.com/smaeckridderkerk/" target="_blank" rel="noopener noreferrer">
                Instagram
              </Link>
            </button>
          </div>

          <div className="button-padding">
            <button className="button">
              <Link to="https://www.facebook.com/people/Smaeck/100064472238646/" target="_blank"
                    rel="noopener noreferrer">
                Facebook
              </Link>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactFooter;